import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchCompanyDropdownLocation = createAsyncThunk('fetchCompanyDropdownLocation', async (_, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/company/dropdown/location`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const companyLocationDropdownSlice = createSlice({
    name: 'companyLocationDropdown',
    initialState: {
        loading: false,
        companyLocationDropdown: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCompanyDropdownLocation.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchCompanyDropdownLocation.fulfilled, (state, action) => {
            state.loading = false;
            state.companyLocationDropdown = action.payload
        })
        builder.addCase(fetchCompanyDropdownLocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default companyLocationDropdownSlice.reducer